/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'translateSelectItems'
})
export class TranslateSelectItemsPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform<T>(items: Array<T>, { translatePath, field = 'label' }: {translatePath: string, field?: string}): T[] {

    if (items && Array.isArray(items)) {

      items = items.map(item => {
        if (item[field]) {
          const selectItemTranslatePath = translatePath ? `${translatePath}.${item[field]}` : item[field];
          this.translateService.stream(selectItemTranslatePath, {
            defaultValue: item[field].charAt(0).toUpperCase() + item[field].slice(1)
          }).subscribe(
            res => item = {...item, [field]: res}
          );
          return item;
        }else{
          return {...item, label: ''};
        }
      });
      return items;
    }
    return null;
  }

}
